// Auto-generated by the generator
// Don't manually edit this file

import {createStore, applyMiddleware, compose, combineReducers} from 'redux'
import createSagaMiddleware from 'redux-saga'
import {router5Middleware as createRouterMiddleware, router5Reducer} from 'redux-router5'
import {router} from '../router'
import {initialState} from './initialState'
import {mapReducer} from './map/reducers'
import {mapEffects} from './map/effects'
import {hospitalReducer} from './hospital/reducers'
import {hospitalEffects} from './hospital/effects'
import {placeReducer} from './place/reducers'
import {placeEffects} from './place/effects'
import {sessionReducer} from './session/reducers'
import {sessionEffects} from './session/effects'
import {gbiProjectReducer} from './gbiProject/reducers'
import {gbiProjectEffects} from './gbiProject/effects'

const sagaMiddleware = createSagaMiddleware()
const routerMiddleware = createRouterMiddleware(router)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
  combineReducers({
    router: router5Reducer,
    map: mapReducer,
    hospital: hospitalReducer,
    place: placeReducer,
    session: sessionReducer,
    gbiProject: gbiProjectReducer,
  }),
  initialState,
  composeEnhancers(applyMiddleware(
    sagaMiddleware, routerMiddleware
  ))
)

mapEffects.forEach(fx => sagaMiddleware.run(fx))
hospitalEffects.forEach(fx => sagaMiddleware.run(fx))
placeEffects.forEach(fx => sagaMiddleware.run(fx))
sessionEffects.forEach(fx => sagaMiddleware.run(fx))
gbiProjectEffects.forEach(fx => sagaMiddleware.run(fx))

export {
  store
}
